import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer'; 
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';
import OurClients from './pages/OurClients';
import BlackoutEssential from "./pages/BlackoutEssential";
import CablesConnectors from "./pages/CablesConnectors";


// ✅ ScrollToTop with smooth effect
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth" // 👈 smooth scroll
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/clients" element={<OurClients />} />
        <Route path="/blackout-essential" element={<BlackoutEssential />} />
        <Route path="/cables-connectors" element={<CablesConnectors />} />
      </Routes>

      <Footer /> 
    </Router>
  );
}

export default App;
